import React, { useState } from "react";
import styled from "styled-components";

const Photo = styled.img`
  width: 100%;
  aspect-ratio: 1;
  object-fit: cover;
  border-radius: 8px;
`;
const Placeholder = styled.div`
  width: 100%;
  aspect-ratio: 1;
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 8px;
  background: #eff8fa;
  color: ${({ theme }) => theme.globalConstants.color.textBody};
  font-size: 32px;
`;

const MentorHeadshot: React.FC<{
  url?: string | null;
  name: string;
}> = ({ url, name }) => {
  const [failedUri, setFailedUri] = useState<string>();

  if (!url || failedUri === url)
    return (
      <Placeholder aria-label={`Photo unavailable for ${name}`} role="img">
        {name
          .split(/\s+/)
          .map((part) => part[0])
          .slice(0, 2)
          .join("")}
      </Placeholder>
    );
  return (
    <Photo
      src={url}
      alt={name}
      loading="lazy"
      decoding="async"
      onError={() => setFailedUri(url)}
    />
  );
};

export default MentorHeadshot;
